import {
    defineMessages
} from 'react-intl';

export default defineMessages({
    viewDetails: {
        id: 'billing.payment history.View details',
        defaultMessage: 'View details'
    }
});